import React, { useRef, useEffect } from 'react'
import ReactSelect, { OptionTypeBase, Props as SelectProps } from 'react-select'
import { useField } from '@unform/core'
import { FormGroup } from '../../styles/form'

interface Props extends SelectProps<OptionTypeBase> {
  name: string
  label?: string
  width?: string
}

const InputSelect: React.FC<Props> = ({ name, label, width, ...rest }) => {
  const selectRef = useRef(null)

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError
  } = useField(name)

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (rest.isMulti) {
          if (!ref.state.value) {
            return []
          }
          return ref.state.value.map((option: OptionTypeBase) => option.value)
        }
        if (!ref.state.value) {
          return null
        }
        return ref.state.value.value
      },
      setValue: (ref: any, value: any) => {
        if (rest.isMulti && Array.isArray(value)) {
          const items = ref?.props?.options?.filter((option: any) =>
            value.includes(option.value)
          )
          ref?.select.setValue(items)
        } else {
          const item = ref?.props?.options?.find(
            (option: any) => option.value === value
          )
          if (item) {
            ref?.select?.setValue(item)
          }
        }
      },
      clearValue: (ref) => {
        ref.select.clearValue()
      }
    })
  }, [fieldName, registerField, rest.isMulti])

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      // background: '#fff',
      // borderColor: '#9e9e9e',
      minHeight: '32px',
      height: '32px',
      boxShadow: state.isFocused ? null : null
    }),

    valueContainer: (provided: any, state: any) => ({
      ...provided,
      height: '32px',
      padding: '0 6px'
    }),

    input: (provided: any, state: any) => ({
      ...provided,
      margin: '0px'
    }),
    indicatorSeparator: (state: any) => ({
      display: 'none'
    }),
    indicatorsContainer: (provided: any, state: any) => ({
      ...provided,
      height: '32px'
    })
  }

  return (
    <FormGroup width={width}>
      {label && <label htmlFor={fieldName}>{label}</label>}
      <div>
        <ReactSelect
          defaultValue={defaultValue}
          ref={selectRef}
          classNamePrefix="react-select"
          placeholder="Opções"
          noOptionsMessage={() => 'Sem opções'}
          styles={customStyles}
          isClearable={true}
          onFocus={clearError}
          {...rest}
        />
      </div>
      {error && <span className="error">{error}</span>}
    </FormGroup>
  )
}

export default InputSelect
